module.exports = __webpack_public_path__ + "static/media/footwear-3.a585f410.jpg";